// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoAppStoreFilledSvg from "@fishx/icons-svg/es/asn/PtoAppStoreFilled";
import FishxIcon from '../components/FishxIcon';

var PtoAppStoreFilled = function PtoAppStoreFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoAppStoreFilledSvg
  }));
};

PtoAppStoreFilled.displayName = 'PtoAppStoreFilled';
export default React.forwardRef(PtoAppStoreFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoAppStoreFilled.js
// module id = 3868
// module chunks = 0